<template>
  <piece-card title="僧众动态">
    <div class="buddhist-body">
      <chart :option="option" class="chart-box" />
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";

export default {
  name: "BuddhistDynamic",
  components: {
    PieceCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {};
  },
  computed: {
    option() {
      // zs: [僧众总数,打卡人数,请假,外派]
      const { sz = [0, 0, 0, 0] } = this.info || {};
      const data = [
        {name: "在寺", value: sz[1]},
        {name: "请假", value: sz[2]},
        {name: "外派", value: sz[3]},
      ]
      return {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "僧众动态",
            type: "pie",
            radius: "90%",
            data,
            avoidLabelOverlap: false,
            percentPrecision: 0,
            label: {
              show: true,
              position: "inside",
              formatter: "{b}\n{d}%",
              color: "#fff",
              fontSize: 13,
              lineHeight: 18,
            },
          },
        ],
      };
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.buddhist-body {
  position: relative;
}
.chart-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 116px;
}
</style>
